import { masterData } from 'api/master/master-data.api';
import { getRoles } from 'api/master/get-roles.api';
import { getUserSpecial } from 'api/master/get-user-special.api';
import { getPartner } from 'api/master/get-partner.api';
import { getGeneral } from 'api/master/get-general.api';

export const masterDataMap = {
  masterData,
  getRoles,
  getUserAM: () => getUserSpecial('am'),
  getUserRecer: () => getUserSpecial('recer'),
  getUserSale: () => getUserSpecial('sale'),
  getPartner,
  getGeneral,
  getUserCv: () => getUserSpecial('userCv'),
};
